// extracted by mini-css-extract-plugin
module.exports = {"low-photo-priority-multi-author":"photo-low-priority-multi-author-m__low-photo-priority-multi-author__2zwrd"};